import { APIEntityType } from '@ardoq/api-types';
import { hasComponentField, hasReferenceField } from './utils/fields';
import type { EnhancedScopeData } from '@ardoq/data-model';

export const getDynamicFilter =
  (
    enhancedScopeDataSourceBranch: EnhancedScopeData,
    enhancedScopeDataTargetBranch: EnhancedScopeData
  ) =>
  (srcObj: any, targetObj: any, key: string) => {
    const srcEntityType = getEntityType(srcObj);
    const targetEntityType = getEntityType(targetObj);
    const isCalculatedField =
      enhancedScopeDataSourceBranch.calculatedFields.has(key) ||
      enhancedScopeDataTargetBranch.calculatedFields.has(key);

    if (
      srcEntityType === APIEntityType.COMPONENT &&
      targetEntityType === APIEntityType.COMPONENT
    ) {
      if (isCalculatedField) {
        return false;
      }

      return (
        hasComponentField(srcObj._id, key, enhancedScopeDataSourceBranch) ||
        hasComponentField(targetObj._id, key, enhancedScopeDataTargetBranch)
      );
    }

    if (
      srcEntityType === APIEntityType.REFERENCE &&
      targetEntityType === APIEntityType.REFERENCE
    ) {
      if (isCalculatedField) {
        return false;
      }

      return (
        hasReferenceField(srcObj._id, key, enhancedScopeDataSourceBranch) ||
        hasReferenceField(targetObj._id, key, enhancedScopeDataTargetBranch)
      );
    }

    return true;
  };

const getEntityType = (obj: any) => obj?.ardoq?.['entity-type'];
